const actions = {
  listarTabletsCadastrados: async () =>
    // context
    // {
    //   status,
    //   per_page,
    //   current_page,
    //   vendor_id,
    //   vendor_id_voucher,
    //   id,
    //   cost_center_search,
    //   plantiff_search,
    //   categoria,
    // }
    {
      // const api = context.rootState.autenticacao.apiLegado;
      // const response = await api.get("vouchers", {
      //   params: {
      //     status,
      //     per_page,
      //     page: current_page,
      //     vendor_id,
      //     vendor_id_voucher,
      //     id,
      //     cost_center_search,
      //     plantiff_search,
      //     categoria,
      //   },
      // });
      return [
        {
          identificador: "teste",
          unidade: "Unidade 1",
          imei: "ITUWEFR-IQIWQHE0WQ-QEQEJQKEH-QEJQEJBQE",
          tipoMaquina: "balcao",
          apiSecret: "dakfakfaifiowoekqplqs,omvndivbgiwueioqqpsmqsoasa",
          apiKey: "sdsls.pgpgodhjiqsyqeuwbnwioksldnaigaigsaufyqudhja",
        },
      ];
    },

  cadastrarTablet: async () =>
    // context
    // {

    // }
    {
      // const api = context.rootState.autenticacao.apiLegado;
      // const response = await api.post("vouchers"});
      return {
        identificador: "teste",
        apiSecret: "dakfakfaifiowoekqplqs,omvndivbgiwueioqqpsmqsoasa",
        apiKey: "sdsls.pgpgodhjiqsyqeuwbnwioksldnaigaigsaufyqudhja",
      };
    },

  salvarOpcoesMaquina: async () =>
    // context
    // {

    // }
    {
      // const api = context.rootState.autenticacao.apiLegado;
      // const response = await api.post("vouchers"});
      return {
        identificador: "teste",
        apiSecret: "dakfakfaifiowoekqplqs,omvndivbgiwueioqqpsmqsoasa",
        apiKey: "sdsls.pgpgodhjiqsyqeuwbnwioksldnaigaigsaufyqudhja",
      };
    },

  detalharConfiguracaoMaquina: async () =>
    // context
    // {
    // tipoMaquina
    // }
    {
      // const api = context.rootState.autenticacao.apiLegado;
      // const response = await api.post("vouchers"});
      return {
        schema: [
          {
            type: "text",
            name: "name1",
            props: {
              label: "Campo 1",
              required: true,
            },
          },
          {
            type: "number",
            name: "name2",
            props: {
              label: "Campo 2",
              required: true,
            },
          },
          {
            type: "select",
            name: "name3",
            props: {
              label: "Campo 3",
              required: true,
              options: [
                { label: "Opção 1", value: 1 },
                { label: "Opção 2", value: 2 },
              ],
            },
          },
          {
            type: "toggle",
            name: "name4",
            props: { label: "Campo 4" },
          },
          {
            type: "number",
            name: "name2",
            props: {
              label: "Campo 2",
              required: true,
            },
          },
        ],
        values: {
          name1: "teste",
          name2: 2,
          name3: 1,
          name4: true,
        },
      };
    },
};

export const refactorTablet = {
  namespaced: true,
  actions,
};
